// extracted by mini-css-extract-plugin
export default {"InputWrapper":"MoneyInput_InputWrapper__B2srk"};